export enum nodeType {
  folder = 'folder',
  category = 'category'
}



// WEBPACK FOOTER //
// ./src/constants/NodeTypes.ts